/**
 * Used to generate swatches
 * @param { Array<string> } skus
 * @returns { string }
 */
export const queryGetManyProductsBySKU = (skus) => {
  if (!skus || !(skus instanceof Array)) {
    throw new Error(`Must provide handles to queryGetManyProductsBySKU; provided: ${typeof skus === 'object' ? JSON.stringify(skus) : skus} `)
  }

  const variables = { query: skus.join(' OR '), first: 50 }
  const query = `
    query searchProducts($query: String!, $first: Int) {
      search(query:$query, first: $first) {
        edges {
          node {
            ... on Product {
              id
              title
              handle
              totalInventory
              featuredImage {
                url
                altText
              }
              images(first: 10) {
                nodes {
                  url
                  altText
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              tags
              options(first: 5) {
                name
              }
              variants(first: 5) {
                edges {
                  node {
                    id
                    availableForSale
                    currentlyNotInStock
                    quantityAvailable
                    title
                    selectedOptions {
                      value
                    }
                    sku
                    earliestPoDate: metafield(namespace: "custom", key: "earliestpodate") {
                      value
                    }
                    onHandStock: metafield(namespace: "custom", key: "onhandstock") {
                      value
                    }
                    futureStock: metafield(namespace: "custom", key: "futurestock") {
                      value
                    }
                  }
                }
              }
              prettyColorName: metafield(namespace: "variant_options", key: "colourway") {
                value
              }
              bundleChilds: metafield(namespace: "linked_products", key: "package_items") {
                value
              }
              colorName: metafield(namespace: "variant_options", key: "colour_swatch") {
                value
              }
              video: metafield(namespace: "custom", key: "product_video") {
                value
              }
              size: metafield(namespace: "variant_options", key: "size") {
                value
              }
            }
          }
        }
      }
    }
  `
  return { query, variables }
}

export const queryChildBundleItemsBySKU = (skus) => {
  if (!skus || !(skus instanceof Array)) {
    throw new Error(`Must provide handles to queryChildBundleItemsBySKU; provided: ${typeof skus === 'object' ? JSON.stringify(skus) : skus} `)
  }

  const variables = { query: skus.join(' OR '), first: 50 }
  const query = `
    query searchProducts($query: String!, $first: Int) {
      search(query:$query, first: $first) {
        edges {
          node {
            ... on Product {
              id
              title
              handle
              variants(first: 1) {
                edges {
                  node {
                    sku
                    onHandStock: metafield(namespace: "custom", key: "onhandstock") {
                      value
                    }
                    futureStock: metafield(namespace: "custom", key: "futurestock") {
                      value
                    }
                    preOrderDate: metafield(namespace: "custom", key: "earliestpodate") {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
  return { query, variables }
}
